// components/ServiceItem.tsx
import React from 'react';
import { Service } from '../types';

interface ServiceItemProps {
  service: Service;
}

const ServiceItem: React.FC<ServiceItemProps> = ({ service }) => (
  <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 ease-in-out">
    {service.icon && <div className="text-5xl text-lime-500 mb-4">{service.icon}</div>}
    <h3 className="text-2xl font-semibold text-slate-800 mb-3">{service.title}</h3>
    {typeof service.description === 'string' ? (
      <p className="text-gray-600">{service.description}</p>
    ) : (
      <ul className="list-disc list-inside text-gray-600 space-y-1">
        {service.description.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    )}
  </div>
);

export default ServiceItem;
